const isEmpty = (text) => {
    return text.length == 0;
};

const isMail = (text) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(text);
};

const isName = (text) => {
    return /^([a-zA-Z])+(\s([a-zA-Z])+)*$/.test(text);
};

const isNickName = (text) => {
    return /^[a-zA-Z]+(_|-|[0-9a-zA-Z])*$/.test(text);
};

const isCellPhone = (text) => {
    return /^([0-9]{10}|([0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{2})|([0-9]{3}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}))$/.test(text);
};

const isHomePhone = (text) => {
    return /^([0-9]{7}|([0-9]{3}-[0-9]{2}-[0-9]{2})|([0-9]{3}\s[0-9]{2}\s[0-9]{2}))$/.test(text);
};

export {isEmpty, isMail, isName, isNickName, isCellPhone, isHomePhone};